import { Component, type ReactNode, type ErrorInfo } from 'react'

import { faArrowRotateRight } from '@fortawesome/pro-light-svg-icons/faArrowRotateRight'
import { HcH } from '@hotmart-org-ca/cosmos-web/dist/react/hc-h'

import type { ErrorBoundaryProps, ErrorBoundaryState } from './types'

import { Button } from '../button'

class ErrorBoundary<P extends ErrorBoundaryProps> extends Component<P, ErrorBoundaryState> {
  constructor(props: P) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    console.error(error, errorInfo)
  }

  reload(): void {
    window.location.reload()
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return (
        <>
          {this.props.imgSrc ? (
            <picture>
              <img src={this.props.imgSrc} alt='Something went wrong' />
            </picture>
          ) : null}
          <HcH strong>Something went wrong.</HcH>
          <Button onClick={this.reload} icon={faArrowRotateRight} iconPosition='end'>
            Reload window
          </Button>
        </>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
